import {
  Badge,
  Body,
  Box,
  Caption,
  Heading,
  ShimmerBox,
  Stack,
} from "@biom3/react";
interface RewardsBannerProps {
  sweepstakeName?: string;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  isLoading: boolean;
}

export const RewardsBanner = ({
  sweepstakeName,
  title,
  description,
  isLoading,
}: RewardsBannerProps) => {
  return (
    <Stack
      direction={{ default: "column", large: "row" }}
      sx={{
        position: "relative",
        width: "100%",
        borderRadius: "base.borderRadius.large",
        overflow: "hidden",
        bg: "base.color.background.surface.secondary",
        pb: "base.spacing.x6",
      }}
    >
      <Box
        sx={{
          flex: 1,
          zIndex: 2,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            maxWidth: "930px",
            width: "100%",
          }}
        >
          {sweepstakeName && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "base.spacing.x2",
                mb: "base.spacing.x4",
              }}
            >
              <Badge badgeContent={"BETA"} variant="emphasis" />
              <Caption
                sx={{
                  color: "base.color.text.caption.primary",
                  textTransform: "uppercase",
                  letterSpacing: "0.1em",
                }}
              >
                PERPETUAL REWARDS: BUILT FOR GAMERS - {sweepstakeName}
              </Caption>
            </Box>
          )}
          <Stack gap="base.spacing.x3">
            <Heading
              size={["medium", "medium", "medium", "large"]}
              weight="bold"
              sx={{
                color: "base.color.text.heading.primary",
              }}
            >
              {isLoading ? (
                <ShimmerBox
                  sx={{
                    height: "48px",
                  }}
                />
              ) : (
                title
              )}
            </Heading>
            <Body
              size="small"
              sx={{
                color: "base.color.text.body.primary",
                lineHeight: "1.6",
                maxWidth: "40rem",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {isLoading ? (
                <ShimmerBox
                  sx={{
                    height: "26px",
                  }}
                />
              ) : (
                description
              )}
            </Body>
          </Stack>
        </Box>
      </Box>
    </Stack>
  );
};
